{
  "aa": "aa-ET",
  "ab": "ab-GE",
  "ae": "ae-IR",
  "af": "af-ZA",
  "ak": "ak-GH",
  "am": "am-ET",
  "an": "an-ES",
  "ar": "ar-SA",
  "as": "as-IN",
  "av": "av-RU",
  "ay": "ay-BO",
  "az": "az-AZ",

  "ba": "ba-RU",
  "be": "be-BY",
  "bg": "bg-BG",
  "bh": "bh-IN",
  "bi": "bi-VU",
  "bm": "bm-ML",
  "bn": "bn-BD",
  "bo": "bo-CN",
  "br": "br-FR",
  "bs": "bs-BA",

  "ca": "ca-ES",
  "ce": "ce-RU",
  "ch": "ch-GU",
  "co": "co-FR",
  "cr": "cr-CA",
  "cs": "cs-CZ",
  "cu": "cu-RU",
  "cv": "cv-RU",
  "cy": "cy-GB",

  "da": "da-DK",
  "de": "de-DE",
  "dv": "dv-MV",
  "dz": "dz-BT",

  "ee": "ee-GH",
  "el": "el-GR",
  "en": "en-GB",
  "eo": "eo-001",
  "es": "es-ES",
  "et": "et-EE",
  "eu": "eu-ES",

  "fa": "fa-IR",
  "ff": "ff-SN",
  "fi": "fi-FI",
  "fj": "fj-FJ",
  "fo": "fo-FO",
  "fr": "fr-FR",
  "fy": "fy-NL",

  "ga": "ga-IE",
  "gd": "gd-GB",
  "gl": "gl-ES",
  "gn": "gn-PY",
  "gu": "gu-IN",
  "gv": "gv-IM",

  "ha": "ha-NG",
  "he": "he-IL",
  "hi": "hi-IN",
  "ho": "ho-PG",
  "hr": "hr-HR",
  "ht": "ht-HT",
  "hu": "hu-HU",
  "hy": "hy-AM",
  "hz": "hz-NA",

  "ia": "ia-001",
  "id": "id-ID",
  "ie": "ie-001",
  "ig": "ig-NG",
  "ii": "ii-CN",
  "ik": "ik-US",
  "io": "io-001",
  "is": "is-IS",
  "it": "it-IT",
  "iu": "iu-CA",

  "ja": "ja-JP",
  "jv": "jv-ID",

  "ka": "ka-GE",
  "kg": "kg-CD",
  "ki": "ki-KE",
  "kj": "kj-AO",
  "kk": "kk-KZ",
  "kl": "kl-GL",
  "km": "km-KH",
  "kn": "kn-IN",
  "ko": "ko-KR",
  "kr": "kr-NE",
  "ks": "ks-IN",
  "ku": "ku-TR",
  "kv": "kv-RU",
  "kw": "kw-GB",
  "ky": "ky-KG",

  "la": "la-VA",
  "lb": "lb-LU",
  "lg": "lg-UG",
  "li": "li-NL",
  "ln": "ln-CD",
  "lo": "lo-LA",
  "lt": "lt-LT",
  "lu": "lu-CD",
  "lv": "lv-LV",

  "mg": "mg-MG",
  "mh": "mh-MH",
  "mi": "mi-NZ",
  "mk": "mk-MK",
  "ml": "ml-IN",
  "mn": "mn-MN",
  "mr": "mr-IN",
  "ms": "ms-MY",
  "mt": "mt-MT",
  "my": "my-MM",

  "na": "na-NR",
  "nb": "nb-NO",
  "nd": "nd-ZW",
  "ne": "ne-NP",
  "ng": "ng-NA",
  "nl": "nl-NL",
  "nn": "nn-NO",
  "no": "no-NO",
  "nr": "nr-ZA",
  "nv": "nv-US",
  "ny": "ny-MW",

  "oc": "oc-FR",
  "oj": "oj-CA",
  "om": "om-ET",
  "or": "or-IN",
  "os": "os-GE",

  "pa": "pa-IN",
  "pi": "pi-IN",
  "pl": "pl-PL",
  "ps": "ps-AF",
  "pt": "pt-PT",

  "qu": "qu-PE",

  "rm": "rm-CH",
  "rn": "rn-BI",
  "ro": "ro-RO",
  "ru": "ru-RU",
  "rw": "rw-RW",

  "sa": "sa-IN",
  "sc": "sc-IT",
  "sd": "sd-PK",
  "se": "se-NO",
  "sg": "sg-CF",
  "si": "si-LK",
  "sk": "sk-SK",
  "sl": "sl-SI",
  "sm": "sm-WS",
  "sn": "sn-ZW",
  "so": "so-SO",
  "sq": "sq-AL",
  "sr": "sr-RS",
  "ss": "ss-SZ",
  "st": "st-LS",
  "su": "su-ID",
  "sv": "sv-SE",
  "sw": "sw-TZ",

  "ta": "ta-IN",
  "te": "te-IN",
  "tg": "tg-TJ",
  "th": "th-TH",
  "ti": "ti-ET",
  "tk": "tk-TM",
  "tl": "tl-PH",
  "tn": "tn-ZA",
  "to": "to-TO",
  "tr": "tr-TR",
  "ts": "ts-ZA",
  "tt": "tt-RU",
  "tw": "tw-GH",
  "ty": "ty-PF",

  "ug": "ug-CN",
  "uk": "uk-UA",
  "ur": "ur-PK",
  "uz": "uz-UZ",

  "ve": "ve-ZA",
  "vi": "vi-VN",
  "vo": "vo-001",

  "wa": "wa-BE",
  "wo": "wo-SN",

  "xh": "xh-ZA",

  "yi": "yi-001",
  "yo": "yo-NG",

  "za": "za-CN",
  "zh": "zh-CN",
  "zu": "zu-ZA"
}
